import clsx from "clsx";
import React from "react";

export type LinkListProps = React.ComponentProps<"div">;
export const LinkList: React.FC<LinkListProps> = React.forwardRef<
  HTMLDivElement,
  LinkListProps
>(({ className, ...props }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={clsx("w-full flex flex-col rounded-lg border", className)}
    />
  );
});
